const CACHE_KEY = 'oh_productos_cache_v4';

/** Códigos tipo 0000000000000 se corrompen si alguien los guarda como Number → 0. */
export function normalizeCodigo(raw) {
  if (raw == null) return '';
  return String(raw).trim();
}

export function codigoLookupKeys(raw) {
  const s = normalizeCodigo(raw);
  if (!s) return [];
  const keys = new Set([s]);
  // Variantes con/sin ceros a la izquierda (sin vaciar del todo)
  if (/^0+\d+$/.test(s)) {
    const stripped = s.replace(/^0+/, '') || '0';
    keys.add(stripped);
    // Restaurar longitud típica EAN/código interno si venía como "0"
    if (s.length >= 8 && stripped !== s) keys.add(stripped.padStart(s.length, '0'));
  }
  if (s === '0' || s === '0.0') {
    keys.add('0000000000000');
    keys.add('000000000000');
  }
  return [...keys];
}

/** Índice codigo → imagen desde el caché del catálogo. */
export function loadProductImageIndex() {
  const map = {};
  try {
    const all = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    Object.values(all || {}).forEach((bucket) => {
      (bucket?.productos || []).forEach((p) => {
        if (!p?.imagen) return;
        const keys = codigoLookupKeys(p.codigo);
        // También por nombre normalizado (fallback Aplicadores, etc.)
        const nombreKey = String(p.nombre || '')
          .trim()
          .toLowerCase();
        keys.forEach((k) => {
          if (k && !map[k]) map[k] = p.imagen;
        });
        if (nombreKey && !map[`n:${nombreKey}`]) map[`n:${nombreKey}`] = p.imagen;
      });
    });
  } catch {
    /* ignore */
  }
  return map;
}

export function lookupImagen(codigo, nombre, index) {
  const byCode = index || loadProductImageIndex();
  for (const k of codigoLookupKeys(codigo)) {
    if (byCode[k]) return byCode[k];
  }
  const nk = String(nombre || '')
    .trim()
    .toLowerCase();
  if (nk && byCode[`n:${nk}`]) return byCode[`n:${nk}`];
  // Heurística conocida: aplicadores individuales
  if (/aplicador/i.test(nk) && byCode['0000000000000']) return byCode['0000000000000'];
  return null;
}

export function enrichItemsWithImages(items = []) {
  const byCode = loadProductImageIndex();
  return (items || []).map((it) => ({
    ...it,
    codigo: normalizeCodigo(it.codigo) || it.codigo,
    imagen: it.imagen || lookupImagen(it.codigo, it.nombre, byCode) || null,
  }));
}
